var _rect, _g, _rect2, _rect3, _g2, _rect4, _rect5, _g3, _rect6, _g4, _rect7, _g5, _rect8, _g6, _g7, _g8, _circle, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudioLocationPermissionsImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 145,
    viewBox: "0 0 229 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6043_2312",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 21,
    width: 107,
    height: 107
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.032,
    y: 34.9037,
    width: 94.0647,
    height: 94.0647,
    transform: "rotate(-8.5 54.032 34.9037)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6043_2312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.2562 65.1559L89.0975 57.4033L120.108 52.7687L121.267 60.5213L90.2562 65.1559ZM94.4903 120.004C92.3583 120.322 90.4198 119.836 88.6747 118.544C86.9295 117.253 85.8977 115.542 85.579 113.41L75.1513 43.636C74.8327 41.504 75.319 39.5655 76.6104 37.8203C77.9017 36.0752 79.6133 35.0434 81.7453 34.7247L120.508 28.9315C122.64 28.6129 124.579 29.0993 126.324 30.3906C128.069 31.6819 129.101 33.3936 129.42 35.5255L139.847 105.299C140.166 107.431 139.68 109.37 138.388 111.115C137.097 112.86 135.385 113.892 133.253 114.21L94.4903 120.004ZM91.5937 108.399L130.357 102.744L123.405 48.3131L84.6419 54.1063L91.5937 108.399Z",
    fill: "#C0DAF1"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28.8843,
    height: 28.943,
    transform: "translate(77.4255 71.8569) rotate(-9)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6043_2312",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 68,
    width: 33,
    height: 33
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 78.7476,
    y: 72.8174,
    width: 27.7289,
    height: 27.7289,
    transform: "rotate(-9 78.7476 72.8174)",
    fill: "url(#paint0_linear_6043_2312)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6043_2312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.5927 84.2181C95.1606 84.1282 95.6139 83.8487 95.9528 83.3797C96.2917 82.9107 96.4161 82.3917 96.3259 81.8228C96.2358 81.2538 95.9566 80.7994 95.4883 80.4596C95.02 80.1197 94.5019 79.9948 93.9341 80.0847C93.3663 80.1746 92.9129 80.4541 92.5741 80.9231C92.2352 81.3921 92.1108 81.9111 92.2009 82.4801C92.291 83.0491 92.5702 83.5035 93.0386 83.8433C93.5069 84.1831 94.0249 84.3081 94.5927 84.2181ZM95.9759 92.9638C97.8913 90.6077 99.2955 88.4163 100.189 86.3896C101.082 84.363 101.419 82.6584 101.2 81.276C100.869 79.1914 99.9371 77.5823 98.4026 76.4488C96.8681 75.3153 95.1221 74.9036 93.1646 75.2136C91.2071 75.5237 89.6738 76.4548 88.5646 78.007C87.4555 79.5592 87.066 81.3776 87.3962 83.4622C87.6151 84.8447 88.4624 86.3616 89.938 88.0131C91.4136 89.6646 93.4262 91.3149 95.9759 92.9638ZM96.3374 95.2462C93.0706 93.2075 90.5495 91.2279 88.7742 89.3076C86.9988 87.3873 85.9689 85.5292 85.6845 83.7333C85.2665 81.0946 85.78 78.8234 87.2249 76.9197C88.6698 75.0161 90.5597 73.8793 92.8947 73.5095C95.2296 73.1397 97.3783 73.6368 99.3408 75.0008C101.303 76.3648 102.493 78.3661 102.911 81.0049C103.196 82.8007 102.79 84.8861 101.695 87.2611C100.6 89.636 98.8144 92.2978 96.3374 95.2462Z",
    fill: "url(#paint1_linear_6043_2312)"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 31.3549,
    height: 28.943,
    transform: "translate(105.233 67.7166) rotate(-9)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6043_2312",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 62,
    width: 36,
    height: 37
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 105.233,
    y: 67.7166,
    width: 31.1737,
    height: 31.1737,
    transform: "rotate(-9 105.233 67.7166)",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6043_2312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.375 82.0431C122.473 82.1859 121.663 82.006 120.943 81.5034C120.223 81.0008 119.795 80.3153 119.657 79.4469L118.476 71.9895C118.338 71.1211 118.534 70.3366 119.063 69.6362C119.593 68.9358 120.308 68.5141 121.21 68.3713C122.111 68.2285 122.922 68.4084 123.642 68.9111C124.361 69.4137 124.79 70.0992 124.928 70.9676L126.109 78.425C126.246 79.2934 126.05 80.0778 125.521 80.7783C124.992 81.4787 124.277 81.9004 123.375 82.0431ZM123.834 91.2074L123.186 87.1106C121.019 87.2136 119.111 86.6142 117.461 85.3124C115.811 84.0106 114.822 82.3279 114.496 80.2644L116.431 79.9578C116.703 81.6771 117.565 83.0431 119.015 84.0557C120.465 85.0682 122.082 85.4331 123.867 85.1504C125.652 84.8677 127.078 84.0208 128.144 82.6097C129.21 81.1986 129.607 79.6334 129.335 77.9141L131.27 77.6075C131.597 79.671 131.177 81.5768 130.01 83.3248C128.843 85.0729 127.213 86.2326 125.121 86.8041L125.77 90.9009L123.834 91.2074ZM123.08 80.1788C123.445 80.1209 123.733 79.9533 123.943 79.6759C124.152 79.3985 124.229 79.0837 124.173 78.7316L122.992 71.2742C122.936 70.922 122.766 70.6464 122.481 70.4474C122.196 70.2483 121.871 70.1777 121.505 70.2357C121.139 70.2936 120.852 70.4612 120.642 70.7386C120.433 71.016 120.356 71.3308 120.411 71.6829L121.593 79.1403C121.648 79.4925 121.819 79.7681 122.104 79.9671C122.389 80.1662 122.714 80.2367 123.08 80.1788Z",
    fill: "url(#paint2_linear_6043_2312)"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 69.8826,
    y: 74.9525,
    width: 8.84363,
    height: 1.10545,
    rx: 0.552727,
    transform: "rotate(26.5 69.8826 74.9525)",
    fill: "url(#paint3_linear_6043_2312)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6043_2312)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.702,
    y: 63.6303,
    width: 8.84363,
    height: 1.10545,
    rx: 0.552727,
    transform: "rotate(146 145.702 63.6303)",
    fill: "url(#paint4_linear_6043_2312)"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 68.1423,
    y: 85.1479,
    width: 8.84363,
    height: 1.10545,
    rx: 0.552727,
    transform: "rotate(-0.499999 68.1423 85.1479)",
    fill: "url(#paint5_linear_6043_2312)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6043_2312)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.858,
    y: 73.4337,
    width: 8.84362,
    height: 1.10545,
    rx: 0.552727,
    transform: "rotate(-5 138.858 73.4337)",
    fill: "url(#paint6_linear_6043_2312)"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 70.3198,
    y: 94.2962,
    width: 8.84363,
    height: 1.10545,
    rx: 0.552727,
    transform: "rotate(-26.5 70.3198 94.2962)",
    fill: "url(#paint7_linear_6043_2312)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6043_2312)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.041,
    y: 80.4011,
    width: 8.84363,
    height: 1.10545,
    rx: 0.552727,
    transform: "rotate(9.5 139.041 80.4011)",
    fill: "url(#paint8_linear_6043_2312)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_6043_2312)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.415,
    cy: 71.0047,
    rx: 8.2909,
    ry: 10.5018,
    transform: "rotate(-14 160.415 71.0047)",
    fill: "url(#paint9_linear_6043_2312)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_6043_2312)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.5852,
    cy: 87.0694,
    rx: 8.2909,
    ry: 10.5018,
    transform: "rotate(-14 56.5852 87.0694)",
    fill: "url(#paint10_linear_6043_2312)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 113.209,
    cy: 111.325,
    r: 1.28425,
    fill: "#A3A3A3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.481,
    cy: 39.6656,
    r: 1.54233,
    fill: "#B0ABAB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6043_2312",
    x: 93.7489,
    y: 27.5539,
    width: 69.4261,
    height: 67.338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.21091,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_6043_2312"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -13.2654,
    dy: -4.42181
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.3709
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.66 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6043_2312"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6043_2312",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6043_2312",
    x: 93.5805,
    y: 42.8618,
    width: 77.3523,
    height: 70.3181,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.10545,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_6043_2312"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -11.0545,
    dy: 4.42181
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.5818
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.388235 0 0 0 0 0.117647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6043_2312"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6043_2312",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6043_2312",
    x: 47.189,
    y: 52.8483,
    width: 100.49,
    height: 66.4991,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -59.6945,
    dy: 4.42181
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.0291
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.0841667 0 0 0 0 0.0841667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6043_2312"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6043_2312",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_6043_2312",
    x: 92.3395,
    y: 0.980511,
    width: 136.151,
    height: 140.048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 29.8184,
    result: "effect1_foregroundBlur_6043_2312"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_6043_2312",
    x: 0.848526,
    y: 29.3839,
    width: 111.473,
    height: 115.371,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.6491,
    result: "effect1_foregroundBlur_6043_2312"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6043_2312",
    x1: 92.508,
    y1: 76.2459,
    x2: 92.612,
    y2: 100.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7000FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6043_2312",
    x1: 93.2557,
    y1: 76.2074,
    x2: 96.3757,
    y2: 95.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66B4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3156A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6043_2312",
    x1: 121.21,
    y1: 68.3713,
    x2: 124.802,
    y2: 91.0542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66B4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3156A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6043_2312",
    x1: 77.4063,
    y1: 75.4367,
    x2: 69.4961,
    y2: 75.6749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#298FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#4416FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3488EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6043_2312",
    x1: 153.226,
    y1: 64.1145,
    x2: 145.316,
    y2: 64.3528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#356BD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6043_2312",
    x1: 76.3929,
    y1: 86.0004,
    x2: 68.655,
    y2: 85.9329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#479BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6043_2312",
    x1: 147.108,
    y1: 74.2862,
    x2: 139.371,
    y2: 74.2187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2685DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6043_2312",
    x1: 70.1075,
    y1: 94.722,
    x2: 79.995,
    y2: 94.7108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3AC2FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6043_2312",
    x1: 138.828,
    y1: 80.8269,
    x2: 148.716,
    y2: 80.8157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B66D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6043_2312",
    x1: 160.415,
    y1: 60.5029,
    x2: 160.415,
    y2: 85.8823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E337FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A88FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6043_2312",
    x1: 56.5852,
    y1: 76.5676,
    x2: 56.5852,
    y2: 101.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCA5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#466FFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioLocationPermissionsImg);
export default __webpack_public_path__ + "static/media/audio_location_permissions_img.70f798a0756a871ba7b615bf9aa84eeb.svg";
export { ForwardRef as ReactComponent };